import _regeneratorRuntime from "/Users/apple/Documents/Personal/exibex/finnovexme/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/apple/Documents/Personal/exibex/finnovexme/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/apple/Documents/Personal/exibex/finnovexme/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/apple/Documents/Personal/exibex/finnovexme/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { calcClosestPtOnSegment, drawPolygonMask, drawPolygonMaskPath, parsePaths, segmentBounce } from "./Utils";
import { deepExtend, itemFromArray } from "../../Utils/Utils";
import { getDistance, getDistances } from "../../Utils/NumberUtils";
import { Constants } from "../../Core/Utils/Constants";
import { PolygonMask } from "./Options/Classes/PolygonMask";
export var PolygonMaskInstance =
/*#__PURE__*/
function () {
  function PolygonMaskInstance(container) {
    _classCallCheck(this, PolygonMaskInstance);

    this.container = container;
    this.dimension = {
      height: 0,
      width: 0
    };
    this.path2DSupported = !!window.Path2D;
    this.options = new PolygonMask();
    this.polygonMaskMoveRadius = this.options.move.radius * container.retina.pixelRatio;
  }

  _createClass(PolygonMaskInstance, [{
    key: "initAsync",
    value: function () {
      var _initAsync = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(options) {
        var polygonMaskOptions;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.options.load(options === null || options === void 0 ? void 0 : options.polygon);
                polygonMaskOptions = this.options;
                this.polygonMaskMoveRadius = polygonMaskOptions.move.radius * this.container.retina.pixelRatio;

                if (!polygonMaskOptions.enable) {
                  _context.next = 6;
                  break;
                }

                _context.next = 6;
                return this.initRawData();

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function initAsync(_x) {
        return _initAsync.apply(this, arguments);
      }

      return initAsync;
    }()
  }, {
    key: "resize",
    value: function resize() {
      var _this = this;

      var container = this.container,
          options = this.options;

      if (!(options.enable && options.type !== "none")) {
        return;
      }

      if (this.redrawTimeout) {
        clearTimeout(this.redrawTimeout);
      }

      this.redrawTimeout = window.setTimeout(
      /*#__PURE__*/
      _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this.initRawData(true);

              case 2:
                _context2.next = 4;
                return container.particles.redraw();

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })), 250);
    }
  }, {
    key: "stop",
    value: function stop() {
      delete this.raw;
      delete this.paths;
    }
  }, {
    key: "particlesInitialization",
    value: function particlesInitialization() {
      var options = this.options;

      if (options.enable && options.type === "inline" && (options.inline.arrangement === "one-per-point" || options.inline.arrangement === "per-point")) {
        this.drawPoints();
        return true;
      }

      return false;
    }
  }, {
    key: "particlePosition",
    value: function particlePosition(position) {
      var _a, _b;

      var options = this.options;

      if (!(options.enable && ((_b = (_a = this.raw) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0)) {
        return;
      }

      return deepExtend({}, position ? position : this.randomPoint());
    }
  }, {
    key: "particleBounce",
    value: function particleBounce(particle, delta, direction) {
      return this.polygonBounce(particle, delta, direction);
    }
  }, {
    key: "clickPositionValid",
    value: function clickPositionValid(position) {
      var options = this.options;
      return options.enable && options.type !== "none" && options.type !== "inline" && this.checkInsidePolygon(position);
    }
  }, {
    key: "draw",
    value: function draw(context) {
      var _a;

      if (!((_a = this.paths) === null || _a === void 0 ? void 0 : _a.length)) {
        return;
      }

      var options = this.options,
          polygonDraw = options.draw;

      if (!options.enable || !polygonDraw.enable) {
        return;
      }

      var rawData = this.raw;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.paths[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var path = _step.value;
          var path2d = path.path2d,
              path2dSupported = this.path2DSupported;

          if (!context) {
            continue;
          }

          if (path2dSupported && path2d && this.offset) {
            drawPolygonMaskPath(context, path2d, polygonDraw.stroke, this.offset);
          } else if (rawData) {
            drawPolygonMask(context, rawData, polygonDraw.stroke);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "polygonBounce",
    value: function polygonBounce(particle, _delta, direction) {
      var options = this.options;

      if (!this.raw || !options.enable || direction !== "top") {
        return false;
      }

      if (options.type === "inside" || options.type === "outside") {
        var closest, dx, dy;
        var pos = particle.getPosition(),
            radius = particle.getRadius();

        for (var i = 0, j = this.raw.length - 1; i < this.raw.length; j = i++) {
          var pi = this.raw[i],
              pj = this.raw[j];
          closest = calcClosestPtOnSegment(pi, pj, pos);
          var dist = getDistances(pos, closest);
          var _ref2 = [dist.dx, dist.dy];
          dx = _ref2[0];
          dy = _ref2[1];

          if (dist.distance < radius) {
            segmentBounce(pi, pj, particle.velocity);
            return true;
          }
        }

        if (closest && dx !== undefined && dy !== undefined && !this.checkInsidePolygon(pos)) {
          var factor = {
            x: 1,
            y: 1
          };

          if (particle.position.x >= closest.x) {
            factor.x = -1;
          }

          if (particle.position.y >= closest.y) {
            factor.y = -1;
          }

          particle.position.x = closest.x + radius * 2 * factor.x;
          particle.position.y = closest.y + radius * 2 * factor.y;
          particle.velocity.mult(-1);
          return true;
        }
      } else if (options.type === "inline" && particle.initialPosition) {
        var _dist = getDistance(particle.initialPosition, particle.getPosition());

        if (_dist > this.polygonMaskMoveRadius) {
          particle.velocity.x = particle.velocity.y / 2 - particle.velocity.x;
          particle.velocity.y = particle.velocity.x / 2 - particle.velocity.y;
          return true;
        }
      }

      return false;
    }
  }, {
    key: "checkInsidePolygon",
    value: function checkInsidePolygon(position) {
      var _a, _b;

      var container = this.container,
          options = this.options;

      if (!options.enable || options.type === "none" || options.type === "inline") {
        return true;
      }

      if (!this.raw) {
        throw new Error(Constants.noPolygonFound);
      }

      var canvasSize = container.canvas.size,
          x = (_a = position === null || position === void 0 ? void 0 : position.x) !== null && _a !== void 0 ? _a : Math.random() * canvasSize.width,
          y = (_b = position === null || position === void 0 ? void 0 : position.y) !== null && _b !== void 0 ? _b : Math.random() * canvasSize.height;
      var inside = false;

      for (var i = 0, j = this.raw.length - 1; i < this.raw.length; j = i++) {
        var pi = this.raw[i],
            pj = this.raw[j],
            intersect = pi.y > y !== pj.y > y && x < (pj.x - pi.x) * (y - pi.y) / (pj.y - pi.y) + pi.x;

        if (intersect) {
          inside = !inside;
        }
      }

      return options.type === "inside" ? inside : options.type === "outside" ? !inside : false;
    }
  }, {
    key: "parseSvgPath",
    value: function parseSvgPath(xml, force) {
      var _a, _b, _c;

      var forceDownload = force !== null && force !== void 0 ? force : false;

      if (this.paths !== undefined && !forceDownload) {
        return this.raw;
      }

      var container = this.container,
          options = this.options,
          parser = new DOMParser(),
          doc = parser.parseFromString(xml, "image/svg+xml"),
          svg = doc.getElementsByTagName("svg")[0];
      var svgPaths = svg.getElementsByTagName("path");

      if (!svgPaths.length) {
        svgPaths = doc.getElementsByTagName("path");
      }

      this.paths = [];

      for (var i = 0; i < svgPaths.length; i++) {
        var path = svgPaths.item(i);

        if (path) {
          this.paths.push({
            element: path,
            length: path.getTotalLength()
          });
        }
      }

      var pxRatio = container.retina.pixelRatio,
          scale = options.scale / pxRatio;
      this.dimension.width = parseFloat((_a = svg.getAttribute("width")) !== null && _a !== void 0 ? _a : "0") * scale;
      this.dimension.height = parseFloat((_b = svg.getAttribute("height")) !== null && _b !== void 0 ? _b : "0") * scale;
      var position = (_c = options.position) !== null && _c !== void 0 ? _c : {
        x: 50,
        y: 50
      };
      this.offset = {
        x: container.canvas.size.width * position.x / (100 * pxRatio) - this.dimension.width / 2,
        y: container.canvas.size.height * position.y / (100 * pxRatio) - this.dimension.height / 2
      };
      return parsePaths(this.paths, scale, this.offset);
    }
  }, {
    key: "downloadSvgPath",
    value: function () {
      var _downloadSvgPath = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(svgUrl, force) {
        var options, url, forceDownload, req;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                options = this.options, url = svgUrl || options.url, forceDownload = force !== null && force !== void 0 ? force : false;

                if (!(!url || this.paths !== undefined && !forceDownload)) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return", this.raw);

              case 3:
                _context3.next = 5;
                return fetch(url);

              case 5:
                req = _context3.sent;

                if (req.ok) {
                  _context3.next = 8;
                  break;
                }

                throw new Error("tsParticles Error - Error occurred during polygon mask download");

              case 8:
                _context3.t0 = this;
                _context3.next = 11;
                return req.text();

              case 11:
                _context3.t1 = _context3.sent;
                _context3.t2 = force;
                return _context3.abrupt("return", _context3.t0.parseSvgPath.call(_context3.t0, _context3.t1, _context3.t2));

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function downloadSvgPath(_x2, _x3) {
        return _downloadSvgPath.apply(this, arguments);
      }

      return downloadSvgPath;
    }()
  }, {
    key: "drawPoints",
    value: function drawPoints() {
      if (!this.raw) {
        return;
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.raw[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;
          this.container.particles.addParticle({
            x: item.x,
            y: item.y
          });
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  }, {
    key: "randomPoint",
    value: function randomPoint() {
      var container = this.container,
          options = this.options;
      var position;

      if (options.type === "inline") {
        switch (options.inline.arrangement) {
          case "random-point":
            position = this.getRandomPoint();
            break;

          case "random-length":
            position = this.getRandomPointByLength();
            break;

          case "equidistant":
            position = this.getEquidistantPointByIndex(container.particles.count);
            break;

          case "one-per-point":
          case "per-point":
          default:
            position = this.getPointByIndex(container.particles.count);
        }
      } else {
        position = {
          x: Math.random() * container.canvas.size.width,
          y: Math.random() * container.canvas.size.height
        };
      }

      if (this.checkInsidePolygon(position)) {
        return position;
      } else {
        return this.randomPoint();
      }
    }
  }, {
    key: "getRandomPoint",
    value: function getRandomPoint() {
      if (!this.raw || !this.raw.length) {
        throw new Error(Constants.noPolygonDataLoaded);
      }

      var coords = itemFromArray(this.raw);
      return {
        x: coords.x,
        y: coords.y
      };
    }
  }, {
    key: "getRandomPointByLength",
    value: function getRandomPointByLength() {
      var _a, _b, _c;

      var options = this.options;

      if (!this.raw || !this.raw.length || !((_a = this.paths) === null || _a === void 0 ? void 0 : _a.length)) {
        throw new Error(Constants.noPolygonDataLoaded);
      }

      var path = itemFromArray(this.paths),
          distance = Math.floor(Math.random() * path.length) + 1,
          point = path.element.getPointAtLength(distance);
      return {
        x: point.x * options.scale + (((_b = this.offset) === null || _b === void 0 ? void 0 : _b.x) || 0),
        y: point.y * options.scale + (((_c = this.offset) === null || _c === void 0 ? void 0 : _c.y) || 0)
      };
    }
  }, {
    key: "getEquidistantPointByIndex",
    value: function getEquidistantPointByIndex(index) {
      var _a, _b, _c, _d, _e, _f, _g;

      var options = this.container.actualOptions,
          polygonMaskOptions = this.options;
      if (!this.raw || !this.raw.length || !((_a = this.paths) === null || _a === void 0 ? void 0 : _a.length)) throw new Error(Constants.noPolygonDataLoaded);
      var offset = 0,
          point;
      var totalLength = this.paths.reduce(function (tot, path) {
        return tot + path.length;
      }, 0),
          distance = totalLength / options.particles.number.value;
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = this.paths[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var path = _step3.value;
          var pathDistance = distance * index - offset;

          if (pathDistance <= path.length) {
            point = path.element.getPointAtLength(pathDistance);
            break;
          } else {
            offset += path.length;
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return {
        x: ((_b = point === null || point === void 0 ? void 0 : point.x) !== null && _b !== void 0 ? _b : 0) * polygonMaskOptions.scale + ((_d = (_c = this.offset) === null || _c === void 0 ? void 0 : _c.x) !== null && _d !== void 0 ? _d : 0),
        y: ((_e = point === null || point === void 0 ? void 0 : point.y) !== null && _e !== void 0 ? _e : 0) * polygonMaskOptions.scale + ((_g = (_f = this.offset) === null || _f === void 0 ? void 0 : _f.y) !== null && _g !== void 0 ? _g : 0)
      };
    }
  }, {
    key: "getPointByIndex",
    value: function getPointByIndex(index) {
      if (!this.raw || !this.raw.length) {
        throw new Error(Constants.noPolygonDataLoaded);
      }

      var coords = this.raw[index % this.raw.length];
      return {
        x: coords.x,
        y: coords.y
      };
    }
  }, {
    key: "createPath2D",
    value: function createPath2D() {
      var _this2 = this;

      var _a, _b;

      var options = this.options;

      if (!this.path2DSupported || !((_a = this.paths) === null || _a === void 0 ? void 0 : _a.length)) {
        return;
      }

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        var _loop = function _loop() {
          var path = _step4.value;
          var pathData = (_b = path.element) === null || _b === void 0 ? void 0 : _b.getAttribute("d");

          if (pathData) {
            var path2d = new Path2D(pathData),
                matrix = document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGMatrix(),
                finalPath = new Path2D(),
                transform = matrix.scale(options.scale);

            if (finalPath.addPath) {
              finalPath.addPath(path2d, transform);
              path.path2d = finalPath;
            } else {
              delete path.path2d;
            }
          } else {
            delete path.path2d;
          }

          if (path.path2d || !_this2.raw) {
            return "continue";
          }

          path.path2d = new Path2D();
          path.path2d.moveTo(_this2.raw[0].x, _this2.raw[0].y);

          _this2.raw.forEach(function (pos, i) {
            var _a;

            if (i > 0) {
              (_a = path.path2d) === null || _a === void 0 ? void 0 : _a.lineTo(pos.x, pos.y);
            }
          });

          path.path2d.closePath();
        };

        for (var _iterator4 = this.paths[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var _ret = _loop();

          if (_ret === "continue") continue;
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
    }
  }, {
    key: "initRawData",
    value: function () {
      var _initRawData = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(force) {
        var options, data, svg, path, namespaces;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                options = this.options;

                if (!options.url) {
                  _context4.next = 7;
                  break;
                }

                _context4.next = 4;
                return this.downloadSvgPath(options.url, force);

              case 4:
                this.raw = _context4.sent;
                _context4.next = 8;
                break;

              case 7:
                if (options.data) {
                  data = options.data;

                  if (typeof data !== "string") {
                    path = data.path instanceof Array ? data.path.map(function (t) {
                      return "<path d=\"".concat(t, "\" />");
                    }).join("") : "<path d=\"".concat(data.path, "\" />");
                    namespaces = 'xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"';
                    svg = "<svg ".concat(namespaces, " width=\"").concat(data.size.width, "\" height=\"").concat(data.size.height, "\">").concat(path, "</svg>");
                  } else {
                    svg = data;
                  }

                  this.raw = this.parseSvgPath(svg, force);
                }

              case 8:
                this.createPath2D();

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function initRawData(_x4) {
        return _initRawData.apply(this, arguments);
      }

      return initRawData;
    }()
  }]);

  return PolygonMaskInstance;
}();